/**
 * Live subscription to the SYSTEM Block Examples Library (root
 * `systemBlockLibrary`, read-only catalogue) — pattern: useBlockLibraryExamples.
 * Disabled system examples are filtered out for end users.
 */
import { useEffect, useMemo, useState } from 'react';
import { SystemBlockLibraryService } from '@modules/firebase-core/services/SystemBlockLibraryService';
import type { BlockLibraryExampleDoc } from '@modules/shared-types';

export interface UseSystemBlockLibraryExamplesResult {
  examples: BlockLibraryExampleDoc[];
  loading: boolean;
  error: Error | null;
}

export function useSystemBlockLibraryExamples(): UseSystemBlockLibraryExamplesResult {
  const service = useMemo(() => new SystemBlockLibraryService(), []);
  const [examples, setExamples] = useState<BlockLibraryExampleDoc[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    setExamples([]);
    setLoading(true);
    setError(null);
    return service.subscribe((next) => {
      setExamples(next.filter((example) => example.enabled));
      setLoading(false);
    }, (nextError) => {
      setError(nextError);
      setLoading(false);
    });
  }, [service]);

  return { examples, loading, error };
}
